<template>
  <div class="landing">
    <div class="l-top">
      <img
        class="background-landing-img"
        src="@/assets/images/landing/landing_bg.png"
        alt="landing-background"
      />

      <div class="lt-group">
        <div class="ltg-background">
          <h3>จะทำธุรกิจต้องรู้เรื่อง<br />ภาษีอะไรบ้าง?</h3>
          <material-button
            class="ltg-button"
            style="width: 244px;"
            @clickButton="onTry"
          >
            ลองเลย
          </material-button>
        </div>

        <div class="wrap-term-condition">
          <div class="condition-text">
            ผลิตภัณฑ์การให้ความรู้ทางภาษีแบบดิจิทัล<b
              >ไม่มีการเก็บข้อมูลส่วนบุคคลหรือข้อมูลตัวเลขจากการคำนวณ</b
            ><br />
            และไม่มีส่วนรับผิดชอบและความผูกพันตามกฎหมายใดๆทั้งสิ้น
          </div>
          <div class="go-term-and-condition" @click="goTermAndCondition()">
            <span class="underline">ข้อกำหนดการใช้งาน</span>
            <img
              class="rvybaqd-img"
              src="@/assets/icons/caret-white-link-info.svg"
              alt="chevron-right"
            />
          </div>
        </div>
        <div class="ltg-detail" @click="goto('try-play')">
          <h4 class="ltgd-link">
            ดูรายละเอียดเพิ่มเติม
          </h4>
          <img
            class="ltgd-svg"
            src="@/assets/icons/chevron-down-solid 1.svg"
            alt="arrow-down"
          />
        </div>
      </div>
    </div>

    <div class="l-body" ref="try-play">
      <img
        src="@/assets/images/landing/background2.png"
        alt="landing-background"
        class="landing-background"
      />
      <h2 class="lb-title">ลองเล่น รู้ เข้าใจ</h2>

      <div class="lb-description">
        Web นี้ช่วยให้คนที่เริ่มต้นทำธุรกิจ หรือมีธุรกิจใน
        การซื้อขายสินค้าและบริการทั่วไป และออนไลน์ รวมทั้งรับรีวิวสินค้า
        Youtuber และอื่นๆ ได้เข้าใจ และสามารถเลือกแนวทางธุรกิจ การวางแผนภาษี
        โดยคำนึงถึงเงินสดในมือ เพื่อการบริหารและ
        เติบโตอย่างยั่งยืนของธุรกิจของคุณ
      </div>

      <div class="wrapper-row">
        <div class="row-img">
          <img
            class="img-mobile"
            src="@/assets/images/landing/try_play_mobile.png"
            alt="Tryplay"
          />

          <img
            class="img-desktop"
            src="@/assets/images/landing/try_play.png"
            alt="Tryplay"
          />
        </div>

        <div class="row-text">
          <h4>ลองเล่น</h4>
          <br />
          <div>
            เลือกรูปแบบและเส้นทาง การวางแผนภาษีสำหรับ การประกอบธุรกิจของคุณ
            ผ่านการตอบคำถามง่ายๆ ในผลิตภัณฑ์การให้ความรู้ภาษี (Digital tax
            literacy product) สามารถย้อนกลับไป เลือกคำตอบได้ใหม่เมื่อเล่นจบ
          </div>
        </div>
      </div>

      <div class="wrapper-row">
        <div class="row-text">
          <h4>รู้</h4>
          <br />
          <div>
            มีคำอธิบายและการเปรียบ เทียบระหว่างการเสียภาษี
            บุคคลธรรมดาและนิติบุคคล
          </div>
        </div>

        <div class="row-img">
          <img
            class="img-mobile"
            src="@/assets/images/landing/know_mobile.png"
            alt="Know"
          />
          <img
            class="img-desktop"
            src="@/assets/images/landing/know.png"
            alt="Know"
          />
        </div>
      </div>

      <div class="wrapper-row">
        <div class="row-img">
          <img
            class="img-mobile"
            src="@/assets/images/landing/understand_mobile.png"
            alt="Understand"
          />

          <img
            class="img-desktop"
            src="@/assets/images/landing/understand.png"
            alt="Understand"
          />
        </div>

        <div class="row-text">
          <h4>เข้าใจ</h4>
          <br />
          <div>
            คุณจะมีความรู้ความเข้าใจ เรื่องภาษี และการบริหาร เงินสดในมือ ดีขึ้น
          </div>
        </div>
      </div>

      <div class="lb-description" style="margin-bottom: 40px;">
        <div>
          เมื่อคุณเล่นจบ <br />คุณสามารถเลือกรูปแบบธุรกิจที่เหมาะสม <br />พร้อม
          tax checklist ที่คุณต้องทำ
        </div>
      </div>

      <material-button
        class="ltg-button button-secondary"
        style="margin-bottom: 90px;"
        @clickButton="onTry"
      >
        ลองเลย
      </material-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Landing",
  components: {},
  data() {
    return {};
  },
  methods: {
    goto(refName) {
      var element = this.$refs[refName];
      element.scrollIntoView({ behavior: "smooth" });
    },
    onTry() {
      this.$router.push("/questions/person_type");
    },
  },
};
</script>

<style scoped>
.landing {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.l-top {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}
.l-top > img {
  width: 100%;
  height: 833px;
  object-fit: cover;
  object-position: 28% 0%;
}
.lt-group {
  position: absolute;
  bottom: 71px;
  z-index: 2;
}
.ltg-background {
  width: 100%;
  height: 100%;
  min-width: 330px;
  min-height: 222px;
  background: #000000cc;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.ltg-background > h3 {
  text-align: center;
}
.ltg-description {
  max-width: 259px;
  text-align: center;
  margin-bottom: 34px;
}
.ltg-button {
  max-width: 352px;
  margin-top: 33px;
}
.wrap-term-condition {
  max-width: 330px;
  margin-top: 8px;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgb(57 61 67 / 0.5);
  padding: 10px 16px;
}
.condition-text {
  font-size: 12px;
  text-align: center;
  margin-bottom: 8px;
}
.go-term-and-condition {
  cursor: pointer;
}
.underline {
  text-decoration: underline;
}
.rvybaqd-img {
  margin-left: 8px;
}
.ltg-detail {
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}
.ltgd-link {
  text-align: center;
  color: #393d43;
}
.ltgd-svg {
  width: 21px;
  height: 24px;
}
.l-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-top: 33px;
}
.l-body > img {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: -2;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.lb-title {
  margin-bottom: 24px;
  color: #29a9e2;
  text-align: center;
}
.lb-description {
  margin-bottom: 74px;
  color: #393d43;
  text-align: center;
  padding: 0 28px;
}

.wrapper-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 59px;
  justify-content: space-between;
  width: 100%;
}
.row-img {
  width: 45%;
  max-width: 200px;
  min-width: 150px;
  min-height: 200px;
  position: relative;
}
.img-mobile {
  width: 100%;
  position: sticky;
  top: 0;
}
.img-desktop {
  width: 100%;
  display: none;
}
.row-text {
  width: 55%;
  max-width: 450px;
  display: flex;
  flex-direction: column;
  padding: 0 28px;
}
.condition-text > br {
  display: none;
}
/*size  >768px */
@media only screen and (min-width: 769px) {
  .lt-group {
    min-width: 788px;
    min-height: 173px;
    justify-content: center;
    bottom: 150px;
  }
  .ltg-background > h3 {
    margin-bottom: 8px;
    max-width: unset;
  }
  .ltg-background > h3 br {
    display: none;
  }
  .ltg-description {
    max-width: unset;
  }
  .l-top > img {
    min-height: 880px;
    height: unset;
  }
  .l-body {
    padding-top: 80px;
  }
  .lb-description {
    max-width: 731px;
    margin-bottom: 80px;
  }
  .lb-description br {
    display: none;
  }
  .wrapper-row {
    flex-direction: row-reverse;
    max-width: 1120px;
  }
  .row-img {
    width: 50%;
    max-width: unset;
    min-width: unset;
    min-height: unset;
  }
  .img-mobile {
    display: none;
  }
  .img-desktop {
    position: sticky;
    top: 0;
    display: inline;
  }

  .row-text {
    width: 50%;
  }
  .row-text h4 {
    font-size: 48px;
  }
  .row-text div {
    width: 350px;
  }
  .row-text br {
    display: none;
  }
  .landing {
    max-width: 1440px;
    margin: auto;
  }
  .condition-text {
    font-size: 14px;
    text-align: center;
    margin-bottom: 8px;
  }
  .wrap-term-condition {
    max-width: 880px;
  }
  .condition-text > br {
    display: inline;
  }
}
</style>
